import * as React from 'react';
import styles from './import-view.scss';
import { ButtonTertiary } from 'ui';
import { MdExpandMore, MdExpandLess } from 'react-icons/md';

export interface ImportExpandDetailsButtonProps {
  id: number;
  showDetails: boolean;
  translation: any;
  handleClose: () => void;
  handleSelect: () => void;
}

export const ImportExpandDetailsButton: React.FC<ImportExpandDetailsButtonProps> = (props: ImportExpandDetailsButtonProps) => {
  const showDetails = props.id && <div className={styles.detailsButton}>
      <ButtonTertiary classNames="btn-block" onClick={props.handleSelect}>
        {props.translation.import_show_details}<MdExpandMore />
      </ButtonTertiary>
    </div>;

    const hideDetails = <div className={styles.detailsButton}>
      <ButtonTertiary classNames="btn-block" onClick={props.handleClose}>
        {props.translation.import_hide_details}<MdExpandLess />
      </ButtonTertiary>
    </div>;

    return props.showDetails ? hideDetails : showDetails;
};
